<i18n>
{
    "ru": {
        "unsubscribe": "Отписаться",
        "unsubscribe_to": "Отписаться от"
    }
}
</i18n>
<template>
    <div class="feed-block-header" :class="rootClasses">
        <div class="feed-block-header__inner">

            <html-link
                v-if="isShowPhoto"
                :url="pictureHref"
                class="feed-block-header__picture-link"
                :class="{'feed-block-header__picture-link_online': online}">

                <img
                    v-if="pictureUrl"
                    class="feed-block-header__picture"
                    :class="pictureClasses"
                    v-lazy-load :data-src="pictureUrl"/>
            </html-link>

            <div class="feed-block-header__content">

                <h6 v-if="isShowName"
                    class="feed-block-header__name">
                    <html-link :url="pictureHref">{{ name }}</html-link>

                    <div v-if="rating && isDetailEntityPage"
                        class="feed-block-header__rating feed-block-header__rating_entity rating"
                        :data-value="parseInt(rating)">
                    </div>
                </h6>

                <div v-if="anons"
                    class="feed-block-header__anons">

                    <!-- eslint-disable-next-line -->
                    <VRuntimeTemplate :template="anonsTemplate" />

                    <div v-if="tags && tags.length"
                        :data-count="tags.length"
                        class="feed-block-header__tags">

                        <base-tag
                            v-for="tag in tags"
                            :key="pictureUrl + tag.code"
                            :name="tag.name"
                            :html-url="tag.htmlUrl"
                            small />

                    </div>
                </div>

                <div v-if="rating && !(getSubToUser || isSelfItem) && !isDetailEntityPage"
                    class="feed-block-header__rating rating"
                    :data-value="parseInt(rating)">
                </div>

                <div
                    v-if="!isSelfItem && !isDetailEntityPage"
                    @mouseover="onMouseOver"
                    @mouseleave="onMouseLeave"
                    class="feed-block-header__actions">

                    <ButtonCebab
                        @click.native="onButtonClick"/>

                    <transition name="fade">
                        <Actions
                            is-tooltip
                            v-if="showActions"
                            :modalItems="getModalItems"/>
                    </transition>

                </div>
            </div>

        </div>

        <div class="feed-block-header__article-title"
            v-if="rating && (getSubToUser || isSelfItem) && !isDetailEntityPage">
            <h6 v-if="entity"
                class="feed-block-header__name">
                <!-- eslint-disable-next-line -->
                <html-link v-html="reviewTitle"
                    :url="reviewLink" />
            </h6>
            <div class="feed-block-header__rating rating"
                :data-value="parseInt(rating)"></div>
        </div>

        <div class="feed-block-header__article-title"
            v-if="articleTitle">
            <!-- eslint-disable-next-line -->
            <h6 v-html="articleTitle"
                class="feed-block-header__name">
            </h6>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VRuntimeTemplate from "v-runtime-template"

import get from 'lodash/get'

import includes from 'lodash/includes'
import map from 'lodash/map'

import ButtonCebab from '@/components/ui/buttons/ButtonCebab'
import Actions from "@/components/modal/ui/Actions";

export default {
    name: 'FeedBlockHeader',
    components: {
        Actions,
        VRuntimeTemplate,
        ButtonCebab
    },
    props: {
        subscriptions: {
            type: Array,
            default: null
        },
        post: {
            type: Boolean,
            default: false
        },
        single: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            default: null
        },
        anons: {
            type: String,
            default: null
        },
        rating: {
            type: [ Number, String ],
            default: null
        },
        pictureUrl: {
            type: String,
            default: null
        },
        pictureHref: {
            type: String,
            default: null
        },
        pictureFormat: {
            type: String,
            default: 'circle',
            validator(format) {
                return includes(['circle', 'square', 'rectangle'], format)
            }
        },
        tags: {
            type: Array,
            default: null
        },
        online: {
            type: Boolean,
            default: false
        },
        articleTitle: {
            type: [ String, Boolean ],
            default: false
        },
        entity: {
            type: [ Object, Boolean ],
            default: false
        }
    },
    data() {
        return {
            showActions: false
        }
    },
    inject: ['getSubToUser', 'isPost', 'isSelfItem'],
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        anonsTemplate() {
            let content = this.anons

            content = this.replaceHtmlLink(content)

            return `<span>${content}</span>`
        },
        withoutUser() {
            return this.isPost && !(this.getSubToUser || this.isSelfItem)
        },
        isShowName() {
            if(this.isDetailEntityPage) return true;
            return this.name && this.isShowPhoto;
        },
        isShowPhoto() {
            if (this.withoutUser) return false

            return !this.tags || (this.tags && this.tags.length < 2)
        },
        rootClasses() {
            return {
                'feed-block-header_single': this.single,
                'feed-block-header_post': this.post,
                'feed-block-header_entity': this.isDetailEntityPage
            }
        },
        pictureClasses() {
            return [
                `feed-block-header__picture_${this.pictureFormat}`
            ]
        },
        getModalItems() {
            return map(this.subscriptions, s => {
                // Не показываем, если пользователь отписался
                const name = (this.subscriptions.length > 1) ?
                    this.$t('unsubscribe_to') + ' ' + s.entity.name :
                    this.$t('unsubscribe')

                return {
                    name,
                    customClass:'popup-actions__link_danger',
                    eventName: 'unsubscribe-feed-block',
                    disabled: s.disabled || false,
                    data: {
                        entity: s.entity,
                        entityTag: s.entity,
                        type: s.entityType,
                        id: s.id
                    }
                }
            })
        },
        reviewTitle(){
            if(get(this.entity, 'brand', false)){
                return get(this.entity, 'brand.name', null)
            }

            if(get(this.entity, 'perfume', false)){
                return get(this.entity, 'perfume.brand.name', null) + ' ' + get(this.entity, 'perfume.name', null)
            }

            if(get(this.entity, 'shop', false)){
                return get(this.entity, 'shop.name', null)
            }

            return false
        },
        reviewLink(){
            if(get(this.entity, 'brand', false)){
                return get(this.entity, 'brand.htmlUrl', null)
            }

            if(get(this.entity, 'perfume', false)){
                return get(this.entity, 'perfume.htmlUrl', null)
            }

            if(get(this.entity, 'shop', false)){
                return get(this.entity, 'shop.htmlUrl', null)
            }

            return false
        },
        isDetailEntityPage(){
            return this.$route.path !== '/feed/';
        }
    },
    methods: {
        replaceHtmlLink(content) {
            const patterns = {
                link: /<a\s+(?:[^>]*?\s+)?href="([^"]*)">([a-zA-Zа-яА-Я\s+]*)<\/a>/gm,
            }

            return content.replace(
                patterns.link,
                (l, href, name) => href && name ? `<html-link url="${href}">${name}</html-link>` : l
            )
        },
        onMouseOver() {
            if (this.isDeviceDesktop) this.showActions = true
        },
        onMouseLeave() {
            if (this.isDeviceDesktop) this.showActions = false
        },
        onButtonClick() {
            if (this.isDeviceDesktop) return

            this.showPopup('actions', {
                modalItems: this.getModalItems
            });
        }
    }
}
</script>

<style lang="less">
.feed-block-header {
    width: 100%;
    flex-wrap: wrap;
    
    &__inner{
        display: flex;
        align-content: flex-start;
        // align-items: center;

        width: 100%;
    }

    &_single {
        padding: rem(24) 0;

        align-items: center;

        @{mobile} &{
            padding-left: rem(20);
            padding-right: rem(20);
        }
    }

    &_post {
        padding: rem(24) 0 rem(19);
    }

    &_entity{
        .feed-block-header{
            &__content{
                padding-right: 0;
                min-width: 0;
            }

            &__name{
                display: flex;
                justify-content: space-between;
                align-items: center;

                a{
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }
            }

            &__rating{
                flex: 0 0 auto;
            }

            &__anons{
                a{
                    display: none;

                    &:only-child{
                        display: inline;
                    }
                }

                &::first-letter{
                    text-transform: uppercase;
                }
            }
        }
    }

    &__picture {
        object-fit: contain;
        display: block;

        height: rem(40);
        width: rem(40);

        &_rectangle {
            width: rem(71);
        }

        &_circle {
            object-fit: cover;

            border-radius: 50%;
        }

        &-link {
            display: block;
            margin-right: rem(16);
            align-self: flex-start;

            &_online{
                position: relative;

                &::after{
                    content: "";
                    border: rem(1) solid white;
                    border-radius: 50%;
                    height: rem(10);
                    width: rem(10);
                    position: absolute;
                    right: rem(2);
                    bottom: rem(1);
                    background-color: @color-green;
                }
            }
        }
    }

    &__anons {
        color: @color-gray;
        font-size: rem(13);

        & > span {
            margin-right: rem(8);

            & > a {
                color: @color-black;
                text-decoration: underline;

                .hover({
                    color: @color-primary;
                });
            }
        }
    }

    &__rating {
        --star-width: rem(18);
        --star-height: rem(14);
        height: rem(14);
        transform: translate(rem(-3), rem(-1));
    }

    &__actions {
        position: absolute;
        top: 0;
        right: 0;
    }

    &__content {
        padding-right: rem(36);

        width: 100%;

        position: relative;
    }

    &__name {
        color: @color-black;
        font-size: rem(15);
        font-weight: 500;
        line-height: 1.5;
        margin: 0 0 rem(2);

        a {
            color: inherit;

            .hover({
                color: @color-primary;
            });
        }
    }

    &__picture-link:hover ~ &__content &__name {
        @media @hover {
            color: @color-primary;
        }
    }

    &__tags {
        display: flex;
        align-items: center;

        font-size: 0;

        margin-top: rem(8);

        height: rem(13);

        @{desktop} & {
            display: inline-flex;

            margin-top: rem(0);
        }

        .base-tag {
            margin-right: rem(8);
        }

        &:not([data-count="1"]) {
            flex-wrap: wrap;

            height: auto;

            @{desktop} & {
                margin-bottom: rem(-8);
            }

            &:not([data-count="2"]) {
                display: flex;

                margin-top: rem(8);
            }

            .base-tag {
                margin-bottom: rem(8);
            }
        }
    }

    &__article-title{
        margin-top: rem(16);
        margin-bottom: rem(-12);
        flex: 0 0 100%;
        display: flex;
        align-items: center;

        .feed-block-header__name{
            margin-bottom: 0;
            margin-right: rem(6);
        }
        // .feed-block-header__rating{
        //     transform: none;
        // }
    }
}
</style>
